import { useEffect, useRef } from 'react';

export function useChangeEffect(callback: () => void, dependency: unknown) {
    const effectCallback = useRef(callback);
    const prevValue = useRef(dependency);

    useEffect(() => {
        effectCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        if (prevValue.current == dependency) {
            return;
        }

        prevValue.current = dependency;

        effectCallback.current();
    }, [dependency]);
}
